import { openInNewTab } from "@/utils/open-in-new-tab";
import queries from "@/queries";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

// ============================================
// useOpenReport
// 보고서(워크북)의 첫 카테고리를 조회해 매핑 화면을 새 탭으로 연다.
// 최근 수정 섹션·보고서 목록이 공유한다.
// ============================================

export const useOpenReport = () => {
  const queryClient = useQueryClient();

  return useCallback(
    async (reportId: string) => {
      try {
        const data = await queryClient.fetchQuery(
          queries.workbook(reportId)._ctx.categories(),
        );
        const firstCategory = [...(data?.categories ?? [])].sort((a, b) =>
          a.category.localeCompare(b.category, "ko", { numeric: true }),
        )[0];
        if (firstCategory) {
          openInNewTab(`/mapping/${reportId}/${firstCategory.id}`);
        }
      } catch (error) {
        console.error("보고서 열기 실패:", error);
      }
    },
    [queryClient],
  );
};
